module.exports = __webpack_public_path__ + "static/media/serviceArrow.bba85e44.svg";